import { Transform } from 'class-transformer';
import repeat from 'lodash/repeat';
import { v4 as uuidv4 } from 'uuid';

import TypeAction from '@/decorators/type_action';
import TypeContent from '@/decorators/type_content';
import TypeStyle from '@/decorators/type_style';
import { ActionBase } from '@/models/action_base';
import { ContentFooterModel } from '@/models/content_footer_model';
import { ContentTrackingIdModel } from '@/models/content_tracking_id_model';
import { generate, registerGenerator } from '@/utils/generate';

import { ContentBase } from './content_base';
import { ContentButtonModel } from './content_button_model';
import { ContentImageModel } from './content_image_model';
import { ContentLinkModel } from './content_link_model';
import { ContentTextEditorModel } from './content_text_editor_model';
import { ContentVideoModel } from './content_video_model';
import { Model } from './model';
import { Style } from './style';

export class Page extends Model<Page> {
  title: string = '';

  path: string = '';

  uniqueKey: string = uuidv4();

  @TypeStyle({
    defaultStyle: {
      marginTop: '0',
      marginRight: '0',
      marginBottom: '0',
      marginLeft: '0',
      paddingTop: '0',
      paddingRight: '0',
      paddingBottom: '0',
      paddingLeft: '0',
    },
  })
  style?: Style;

  @TypeStyle({
    defaultStyle: {
      marginTop: '0',
      marginRight: '0',
      marginBottom: '0',
      marginLeft: '0',
      paddingTop: '0',
      paddingRight: '0',
      paddingBottom: '0',
      paddingLeft: '0',
    },
  })
  bodyStyle?: Style;

  @TypeContent()
  @Transform((params) => params.value || [])
  headers: ContentBase[] = [];

  @TypeContent()
  @Transform((params) => params.value || [])
  contents: ContentBase[] = [];

  @TypeContent()
  @Transform((params) => params.value || [])
  footers: ContentBase[] = [];

  @TypeAction()
  @Transform((params) => params.value || [])
  actions: ActionBase[] = [];

  headerSticky = false;

  footerSticky = false;

  useDefaultTitle: boolean = false;

  constructor(init?: Partial<Page>) {
    super();
    Object.assign(this, init);
  }
}

registerGenerator(
  Page,
  (props) => new Page({
    path: repeat('path', props.size),
    title: repeat('任意のタイトル', props.size),
    style: new Style({
      backgroundColor: '#5F5F5F',
      color: 'white',
    }),
    bodyStyle: new Style({
      backgroundColor: '#FFFFFF',
      color: 'black',
    }),
    headers: [
      generate(ContentTextEditorModel, props),
    ],
    contents: [
      generate(ContentImageModel, props),
      generate(ContentTextEditorModel, props),
      generate(ContentButtonModel, props),
      generate(ContentVideoModel, props),
      generate(ContentLinkModel, props),
      generate(ContentFooterModel, props),
      generate(ContentTrackingIdModel, props),
    ],
    footers: [
      generate(ContentTextEditorModel, props),
    ],
    actions: [],
  }),
);
